import { h1, paragraph } from "@/styles/typography";
import { GatsbyImage } from "gatsby-plugin-image";
import styled from "styled-components";

const Container = styled.div<{ isHome: boolean }>`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  margin-top: ${({ isHome }) => (isHome ? "0" : "210px")};
  margin-bottom: 64px;

  @media screen and (max-width: 680px) {
    margin-top: 210px;
    margin-bottom: 17px;
  }
`;

const ImageWrapper = styled.div`
  width: 100%;
  height: 100%;
  z-index: -1;
  margin-bottom: 62px;
  padding: 0 40px;

  @media screen and (max-width: 680px) {
    padding: 0px 16px;
  }
`;

const Image = styled(GatsbyImage)`
  width: 100%;
  object-fit: cover;
  object-position: center;
  aspect-ratio: 16 / 9;
`;

const BackgroundVideo = styled.div`
  width: 100%;
  height: 100%;
  z-index: -1;
  margin-bottom: 62px;
  padding: 0 40px;

  @media screen and (max-width: 680px) {
    margin-bottom: 10px;
    padding: 0px 16px;
  }

  video {
    width: 100%;
    height: 100%;
    aspect-ratio: 16 / 9;
    object-fit: cover;
    object-position: center;
  }
`;

const TextContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 50px;

  @media screen and (max-width: 680px) {
    flex-direction: column;
    gap: 14px;
  }
`;

const TitleWrapper = styled(h1)`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: -12px;

  @media screen and (max-width: 680px) {
    margin-top: -45px;
  }
`;

const Title1 = styled.span`
  color: ${({ theme }) => theme.colors.tango};
`;
const Title2 = styled.span`
  color: ${({ theme }) => theme.colors.softBlack};
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media screen and (max-width: 680px) {
    width: 100%;
  }
`;

const Subtitle = styled(paragraph)`
  font-weight: 400;
`;

const Text = styled(paragraph)<{ isTextLimited: boolean }>`
  color: ${({ theme }) => theme.colors.softBlack};
  overflow: ${({ isTextLimited }) => (isTextLimited ? "hidden" : "visible")};
  height: ${({ isTextLimited }) => (isTextLimited ? "150px" : "100%")};
  margin-bottom: 10px;

  @media screen and (${({ theme }) => theme.breakpoints.sm}) {
    height: ${({ isTextLimited }) => (isTextLimited ? "100px" : "100%")};
  }
`;

const ShowMore = styled(paragraph)<{ isTextLimited: boolean }>`
  color: ${({ theme }) => theme.colors.tango};
  cursor: pointer;

  ${({ isTextLimited }) =>
    isTextLimited &&
    `
  margin-top: 11px;
  `}
`;

const VimeoHero = styled.div<{ isHome: boolean }>`
  width: 100%;
  aspect-ratio: 16/9;
  overflow: hidden;
  position: relative;
  margin-bottom: 62px;

  ${({ isHome }) =>
    !isHome &&
    `
    padding: 0 40px;
    @media screen and (max-width: 680px) {
      padding: 0px 16px;
    }
    `}

  /* &::after {
    // overlay
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    aspect-ratio: 16 / 9;
    width: calc(100% - 80px);
    background: rgba(0, 0, 0, 0.1);

    @media screen and (max-width: 680px) {
      width: calc(100% - 32px);
    }
  } */

  iframe {
    position: absolute;
    width: 100%;
    aspect-ratio: 16/9;
    left: 50%;
    border: none;
    top: 50%;
    transform: translate(-50%, -50%);
    background-color: ${({ theme }) => theme.colors.pearlBush};

    ${({ isHome }) =>
      !isHome &&
      `
    padding: 0 40px;
    @media screen and (max-width: 680px) {
      padding: 0px 16px;
    }
    `}
  }
`;

const IFrame = styled.iframe`
  position: absolute;
  width: 100%;
  aspect-ratio: 16/9;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;

const Video = styled.video``;
const S = {
  Container,
  TextContainer,
  TitleWrapper,
  Title1,
  Title2,
  TextWrapper,
  ImageWrapper,
  Image,
  BackgroundVideo,
  Subtitle,
  Text,
  Video,
  ShowMore,
  VimeoHero,
  IFrame,
};

export default S;
